function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "UxABBy_00000003789062958826278870000004994988848449211298_",
  transform: "translate(-5.675 -3.675)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3123",
  "data-name": "Group 3123"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3491",
  "data-name": "Path 3491",
  d: "M5.8,11.8V5.1a1.424,1.424,0,0,1,.9-1.3H16.8a1.208,1.208,0,0,1,1.3,1.3V18.4a1.208,1.208,0,0,1-1.3,1.3H7.1a1.208,1.208,0,0,1-1.3-1.3Q5.8,15.1,5.8,11.8Zm11.7,0V5.1c0-.5-.2-.7-.7-.7H7.1c-.5,0-.7.2-.7.7V18.4c0,.5.2.7.7.7h9.6c.5,0,.7-.2.7-.7C17.5,16.2,17.5,14,17.5,11.8Z",
  fill: "#fff",
  stroke: "#f7f7f7",
  strokeMiterlimit: 10,
  strokeWidth: 0.25
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3122",
  "data-name": "Group 3122"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3119",
  "data-name": "Group 3119"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3492",
  "data-name": "Path 3492",
  d: "M9.8,8.5H9.2a.684.684,0,0,1-.7-.7V7.2a.684.684,0,0,1,.7-.7h.6a.684.684,0,0,1,.7.7v.6A.684.684,0,0,1,9.8,8.5Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3493",
  "data-name": "Path 3493",
  d: "M12.2,8.5h-.6a.684.684,0,0,1-.7-.7V7.2a.684.684,0,0,1,.7-.7h.6a.684.684,0,0,1,.7.7v.6A.684.684,0,0,1,12.2,8.5Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3494",
  "data-name": "Path 3494",
  d: "M14.6,8.5H14a.684.684,0,0,1-.7-.7V7.2a.684.684,0,0,1,.7-.7h.6a.684.684,0,0,1,.7.7v.6A.684.684,0,0,1,14.6,8.5Z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3120",
  "data-name": "Group 3120"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3495",
  "data-name": "Path 3495",
  d: "M9.8,11.4H9.2a.684.684,0,0,1-.7-.7v-.6a.684.684,0,0,1,.7-.7h.6a.684.684,0,0,1,.7.7v.6A.684.684,0,0,1,9.8,11.4Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3496",
  "data-name": "Path 3496",
  d: "M12.2,11.4h-.6a.684.684,0,0,1-.7-.7v-.6a.684.684,0,0,1,.7-.7h.6a.684.684,0,0,1,.7.7v.6A.684.684,0,0,1,12.2,11.4Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3497",
  "data-name": "Path 3497",
  d: "M14.6,11.4H14a.684.684,0,0,1-.7-.7v-.6a.684.684,0,0,1,.7-.7h.6a.684.684,0,0,1,.7.7v.6A.684.684,0,0,1,14.6,11.4Z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3121",
  "data-name": "Group 3121"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3498",
  "data-name": "Path 3498",
  d: "M9.8,14.3H9.2a.684.684,0,0,1-.7-.7V13a.684.684,0,0,1,.7-.7h.6a.684.684,0,0,1,.7.7v.6A.684.684,0,0,1,9.8,14.3Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3499",
  "data-name": "Path 3499",
  d: "M12.2,14.3h-.6a.684.684,0,0,1-.7-.7V13a.684.684,0,0,1,.7-.7h.6a.684.684,0,0,1,.7.7v.6A.684.684,0,0,1,12.2,14.3Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3500",
  "data-name": "Path 3500",
  d: "M12.2,17.3h-.6a.684.684,0,0,1-.7-.7V16a.684.684,0,0,1,.7-.7h.6a.684.684,0,0,1,.7.7v.6A.684.684,0,0,1,12.2,17.3Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3501",
  "data-name": "Path 3501",
  d: "M15.3,13v.6a.684.684,0,0,1-.7.7H14a.684.684,0,0,1-.7-.7V13a.684.684,0,0,1,.7-.7h.6A.684.684,0,0,1,15.3,13Z",
  fill: "#fff"
})))));

function SvgNumpad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.55,
    height: 16.15,
    viewBox: "0 0 12.55 16.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumpad);
export default __webpack_public_path__ + "static/media/numpad.131da234.svg";
export { ForwardRef as ReactComponent };